import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Forms } from './form.model';
import { environment } from './../../environments/environment';

@Injectable()
export class FormService {

  constructor(private httpClient: HttpClient) {}

  items(query: any): Observable<Forms> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<Forms>(environment.api + '/forms', { params: params });
  }

  public save(data: any): Observable<any> {
    return this.httpClient.post(environment.api + '/form', data);
  }

  public forms(id: number): Observable<any> {
    return this.httpClient.get<any>(environment.api + '/forms/' + id);
  }

}

